/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import PatientActivationsverifyPatientActivation from './PatientActivationsverifyPatientActivation';

/**
 * The PatientActivationsVerifyBody model module.
 * @module model/PatientActivationsVerifyBody
 * @version v0.3
 */
export default class PatientActivationsVerifyBody {
  /**
   * Constructs a new <code>PatientActivationsVerifyBody</code>.
   * @alias module:model/PatientActivationsVerifyBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>PatientActivationsVerifyBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PatientActivationsVerifyBody} obj Optional instance to populate.
   * @return {module:model/PatientActivationsVerifyBody} The populated <code>PatientActivationsVerifyBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PatientActivationsVerifyBody();
      if (data.hasOwnProperty('patient_activation'))
        obj.patientActivation = PatientActivationsverifyPatientActivation.constructFromObject(data['patient_activation']);
    }
    return obj;
  }
}

/**
 * @member {module:model/PatientActivationsverifyPatientActivation} patientActivation
 */
PatientActivationsVerifyBody.prototype.patientActivation = undefined;
